/* tslint:disable: max-classes-per-file */
export { MarkdownComponent, MarkdownConfig, MarkdownModule, MarkdownService } from './markdown';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// /Users/axel/Sites/Bannerboy/Internal/attaboy-angular/node_modules/angular2-markdown/index.js
// module id = ../../../../angular2-markdown/index.js
// module chunks = vendor